
import { MainPublicationModel } from '../models/MainPublicationModel.js';
import { MainPublicationView } from '../views/MainPublicationView.js';

export class MainPublicationController {
    constructor() {

        this.model = new MainPublicationModel();
        this.view = new MainPublicationView();

        this.model.subscribe(state => this.view.render(state));
    }
}